import View from '../View';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Checkout Actions',
  showEmpty: true,
  constraints: {
    ancestors: [{is: 'CommerceCartForm', rule: 'ExactlyOne'}],
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
